import React, { ChangeEvent } from "react";
import { Form } from "react-bootstrap";
import { StringWithFormat } from "../../types/Result";
import { SelectListOption } from "./Types";

export interface IProps {
    name: string,
    checked: boolean,
    disabled?: boolean,
    validationResults?: StringWithFormat[]
    onChange: (value: any, checked: boolean) => void
    onBlur?: () => void
    layout?: 'horizontal' | 'vertical'
    option: SelectListOption
}

const CheckboxListItem: React.FC<IProps> = ({ name, checked, disabled, validationResults, onChange, onBlur, layout, option }) => {

    function onControlChange(e: ChangeEvent<HTMLInputElement>) {
        onChange(option.value, e.target.checked);
    }

    let isValid = validationResults && validationResults.length > 0 ? false : true;
    let width = layout === 'vertical' ? '100%' : undefined

    return (
        <div style={{ marginTop: 10, marginRight: 10, display: 'inline-block', width: width }}>
            <Form.Check type='checkbox' name={name} value={option.value} checked={checked} disabled={disabled} onChange={onControlChange} isInvalid={!isValid} onBlur={onBlur} style={{ height: 20, width: 20, marginRight: 5 }} className="pull-left" />
            {option.label}
        </div>
    )

}
export default CheckboxListItem;